import React from "react";
import EiqQnaPanelAppSync from "./EiqQnaPanelAppSync";

export interface EiqQnaPanelProps {
  webinarId: string;
  userId: string;
  userName: string;
  userEmail?: string;
  role?: "HOST" | "SPEAKER" | "ATTENDEE";
  className?: string;
  hideHeader?: boolean;
}

const EiqQnaPanel: React.FC<EiqQnaPanelProps> = (props) => (
  <EiqQnaPanelAppSync {...props} />
);

export default EiqQnaPanel;
